import React, {  PureComponent  } from 'react';
import { Collapse  } from 'antd';
import { formatMoney } from '../../helpers';
import { invoicesTotal } from './graphicsData';
import CustomLineChart from '../_Generic/LineChart/index';
import EmptyContent from './EmptyContent';
const { Panel } = Collapse;

class Payroll extends PureComponent {

	render() {
		if(!this.props.data)
			return <EmptyContent />;
		const { data,numberOfPayrolls, totalAmountPayrolls,numberOfPayrollsCanceled, numberOfPayrollsDuplicated } = this.props.data;		
		return (
			<Collapse accordion defaultActiveKey={['1']}>
                <Panel header="Información de nóminas" key="1">
                    <div className="box">
						<span className="label">Total de nóminas</span>
						<span className="number-text">{numberOfPayrolls}</span>
					</div>					
					<div className="box">
						<span className="label">Nóminas canceladas</span>
						<span className="number-text">{numberOfPayrollsCanceled}</span>
					</div>
					<div className="box">
						<span className="label">Nóminas duplicadas</span>
						<span className="number-text">{numberOfPayrollsDuplicated}</span>
					</div>
					<div className="box">
						<span className="label">Total en dinero</span>
						<span className="number-text">{formatMoney(totalAmountPayrolls)}</span>
					</div>
                </Panel>
				{
					this.props.data.data && 
					<Panel header="Cantidad de Nóminas timbradas" key="2">
						<CustomLineChart data={invoicesTotal(data)} dataKey="Cantidad" width={300} height={250} stroke="#65DD33" />
					</Panel>
				}
				{
					this.props.data.data && 
					<Panel header="Total de Nóminas" key="3">
						<CustomLineChart data={invoicesTotal(data)} width={300} height={250} stroke="#65DD33" />
					</Panel>
				}
            </Collapse>
		)
	}
}


export default Payroll;